import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LockKey } from '@phosphor-icons/react';
import { Button } from '../ui/button';

/**
 * Shown in place of a screen when the signed-in role has no permission on the
 * module that owns the URL.  The server refuses the data anyway; this tells the
 * person why instead of leaving an empty page.
 */
export function NoAccess({ label }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6" data-testid="no-access">
      <div
        className="max-w-md w-full rounded-xl p-8 text-center"
        style={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-default)' }}
      >
        <div
          className="mx-auto mb-4 h-12 w-12 rounded-full flex items-center justify-center"
          style={{ background: 'var(--accent-primary-soft)' }}
        >
          <LockKey className="h-6 w-6" weight="duotone" style={{ color: 'var(--accent-primary)' }} />
        </div>
        <h2
          className="text-lg mb-2"
          style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, color: 'var(--text-primary)' }}
        >
          No access to {label || 'this module'}
        </h2>
        <p className="text-sm mb-6" style={{ color: 'var(--text-secondary)' }}>
          Your role does not include this module. An administrator can grant it under
          Role &amp; Permissions.
        </p>
        <Button onClick={() => navigate('/dashboard')} data-testid="no-access-home">
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
}

export default NoAccess;
